async function getSha256Key(email: string) {
  const enc = new TextEncoder();
  // SHA-256 generates an exact 32-byte (256-bit) key from any string length
  return await window.crypto.subtle.digest("SHA-256", enc.encode(email));
}

export async function encryptPassword(password: string, encryptionKey: string) {
  const enc = new TextEncoder();
  const keyBuffer = await getSha256Key(encryptionKey);

  // 1. Generate 12-byte nonce (IV)
  const nonce = window.crypto.getRandomValues(new Uint8Array(12));

  // 2. Import derived key
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  // 3. Encrypt (Web Crypto returns [Ciphertext][Tag(16)])
  const encryptedBuffer = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv: nonce, tagLength: 128 },
    cryptoKey,
    enc.encode(password)
  );

  const encryptedBytes = new Uint8Array(encryptedBuffer);
  
  // Extract Ciphertext and Tag parts
  const cipherBytes = encryptedBytes.slice(0, encryptedBytes.length - 16);
  const tagBytes = encryptedBytes.slice(encryptedBytes.length - 16);

  // 4. Rearrange array to match C# layout: [Nonce(12)][Tag(16)][Ciphertext]
  const result = new Uint8Array(nonce.length + tagBytes.length + cipherBytes.length);
  result.set(nonce, 0);
  result.set(tagBytes, 12);
  result.set(cipherBytes, 28);

  // 5. Convert to Base64
  return btoa(String.fromCharCode(...result));
}